export const TextDomain = 'tt-filtered-posts';
